// xp URLS
export const GET_AUTH_CONTENT = () => 'languages.json';
export const GET_CAREPLAN_CONTENT = () => 'careplancontent.json';
export const GET_AUTH_TOKEN = (lang, uniquelink, uniquekey, dob) =>
    `v2/auth/xp/member/${uniquelink}/module/${uniquekey}/dateofbirth/${dob}`;
export const GET_MEMBER_CARE_PLAN_LEGACY = (uniquelink) => `v1/members/${uniquelink}/careplan`;
export const GET_ICONS_URL = () => 'v2/xp/categoryicons';

// LEGACY URLS
export const GET_AUTH_TOKEN_LEGASY = (uniquelink, dob) => `v1/auth/member/${uniquelink}/dateofbirth/${dob}`;
export const GET_MEMBER_CARE_PLAN = (uniquelink, uniquekey) => `v2/xp/member/${uniquelink}/module/${uniquekey}/careplan`;
